import { DeleteTwoTone, EditOutlined, EyeOutlined, SearchOutlined } from '@ant-design/icons';
import React, { useRef, useState } from 'react';
import Highlighter from 'react-highlight-words';
import { Button, Input, Space, Table, Tag } from 'antd';
import { Link } from 'react-router-dom';
import ResponsiveDialog from '../dialog/dialog';
import { useNavigate } from 'react-router-dom';
import serviceService from '../../service/serviceService';

const TableService = ({data, onPageChange, onFilterChange, onSortChange}) => {

  const usuario = JSON.parse(localStorage.getItem('user_token')) || {};
  const permission = usuario.roles?.filter(item=>item.name == "Serviço")[0];

  let navigate = useNavigate();

  const [searchText, setSearchText] = useState('');
  const [searchedColumn, setSearchedColumn] = useState('');
  const searchInput = useRef(null);

  const [activeFilters, setActiveFilters] = useState({});

  const [openDialog, setOpenDialog] = useState();
  const [messageDialog, setMessageDialog] = useState();
  const [titleDialog, setTitleDialog] = useState();
  const [statusDialog, setStatusDialog] = useState();


  function refreshPage() {
    window.location.reload(false);
  }

  /**
   * @function mapColumnToBackend
   * @description Mapear nomes das colunas do frontend para o backend
   * @param {string} columnName - Nome da coluna do frontend
   * @returns 
   */
  const mapColumnToBackend = (columnName) => {
    const mapping = {
      'idservice': 'idservice',
      'name': 'name',
      'type': 'type',
      'vlsale': 'vlSale',
    };
    
    const normalizedColumn = columnName.toLowerCase();
    return mapping[normalizedColumn] || columnName;
  };

  /**
   * @function handleTableChange
   * @description Manipula mudanças na tabela (paginação, ordenação, filtros)
   */
  const handleTableChange = (pagination, filters, sorter) => {
    console.log("🔄 [TableService] Mudança na tabela:", { pagination, filters, sorter });
    
    // Se houver ordenação e onSortChange foi passado
    if (sorter && sorter.columnKey && onSortChange) {
      const sortBy = mapColumnToBackend(sorter.columnKey);
      const sortOrder = sorter.order === 'ascend' ? 'ASC' : sorter.order === 'descend' ? 'DESC' : null;
      
      console.log("📊 [TableService] Ordenação:", { 
        coluna: sorter.columnKey, 
        sortBy, 
        sortOrder 
      });
      
      if (sortOrder) {
        onSortChange(sortBy, sortOrder);
      }
    }
  };

  const handleSearch = (selectedKeys, confirm, dataIndex, close) => {
    console.log("🔍 [TableService] Aplicando filtro:", dataIndex, "=", selectedKeys[0]);
    
    if (selectedKeys[0] && selectedKeys[0].trim() !== "") {
      // Criar novo objeto de filtros ANTES de atualizar o estado
      const newFilters = {
        ...activeFilters,
        [dataIndex]: selectedKeys[0]
      };
      
      const backendFilters = {};
      Object.entries(newFilters).forEach(([key, value]) => {
        const backendKey = mapColumnToBackend(key);
        backendFilters[backendKey] = value;
      });
      
      console.log("📡 [TableService] Filtros frontend:", newFilters);
      console.log("📡 [TableService] Filtros backend:", backendFilters);
      
      // Notificar componente pai IMEDIATAMENTE (antes de atualizar estados)
      if (onFilterChange) {
        onFilterChange(backendFilters);
      }
      
      // DEPOIS atualizar estados locais (apenas para UI)
      setActiveFilters(newFilters);
      setSearchText(selectedKeys[0]);
      setSearchedColumn(dataIndex);
    }
    
    // Fechar dropdown sem confirmar filtro (porque não tem onFilter)
    if (close) {
      close();
    }
  };

  const handleReset = (clearFilters, dataIndex) => {
    console.log("🧹 [TableService] Limpando filtro:", dataIndex);
    
    if (clearFilters) {
      clearFilters();
    }
    
    if (searchedColumn === dataIndex) {
      setSearchText("");
      setSearchedColumn("");
    }

    const newFilters = { ...activeFilters };
    delete newFilters[dataIndex];
    setActiveFilters(newFilters);

    // Mapear colunas para formato do backend
    const backendFilters = {};
    Object.entries(newFilters).forEach(([key, value]) => {
      const backendKey = mapColumnToBackend(key);
      backendFilters[backendKey] = value;
    });

    // Notificar componente pai sobre mudança nos filtros
    if (onFilterChange) {
      console.log("📡 [TableService] Filtros frontend após reset:", newFilters);
      console.log("📡 [TableService] Filtros backend após reset:", backendFilters);
      onFilterChange(backendFilters);
    }
  };

  const getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters, close }) => (
      <div
        style={{
          padding: 8,
        }}
        onKeyDown={(e) => e.stopPropagation()}
      >
        <Input
          ref={searchInput}
          placeholder={`Pesquisar ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
          onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex, close)}
          style={{
            marginBottom: 8,
            display: 'block',
          }}
        />

        <Space>
          <Button
            type="primary"
            onClick={() => handleSearch(selectedKeys, confirm, dataIndex, close)}
            icon={<SearchOutlined />}
            size="small"
            style={{
              width: 90,
            }}
          >
            Procurar
          </Button>
          <Button
            onClick={() => clearFilters && handleReset(clearFilters, dataIndex)}
            size="small"
            style={{
              width: 90,
            }}
          >
            Limpar
          </Button>
          <Button
            type="link"
            size="small"
            onClick={() => {
              close();
            }}
          >
            Fechar
          </Button>
        </Space>
      </div>
    ),

    filterIcon: (filtered) => (
      <SearchOutlined
        style={{
          color: activeFilters[dataIndex] ? '#1677ff' : undefined,
        }}
      />
    ),

    onFilterDropdownOpenChange: (visible) => {
      if (visible) {
        setTimeout(() => searchInput.current?.select(), 100);
      }
    },

    render: (text) =>
      searchedColumn === dataIndex ? (
        <Highlighter
          highlightStyle={{
            backgroundColor: '#ffc069',
            padding: 0,
          }}
          searchWords={[searchText]}
          autoEscape
          textToHighlight={text ? text.toString() : ''}
        />
      ) : (
        text
      ),
  });



  const deleteService = (id) => {

    serviceService.delete(id).then(item=> {
            
      setOpenDialog(true);
      setStatusDialog('success')
      setTitleDialog("Muito bem!")
      setMessageDialog("Serviço deletado com sucesso")

    }).catch(error=>{
        setOpenDialog(true);
        setStatusDialog('error')
        setTitleDialog("Ops!")
        setMessageDialog("Erro ao excluir o serviço, verifique se o mesmo encontra-se inserida em alguma Venda. ")
    })

  }


  const columns = [
    {
        title: 'Código',
        dataIndex: 'idservice',
        width: '13%',
        key: 'idservice',
        // ...getColumnSearchProps('idcustomer'),
        sorter: true,
        sortDirections: ['descend', 'ascend'],
    },
    {
        title: 'Nome',
        dataIndex: 'name',
        key: 'name',
        width: '55%',
        ...getColumnSearchProps('name'),
        sorter: true,
        sortDirections: ['descend', 'ascend'],
    },
    
    {
      title: 'Tipo',
      dataIndex: 'type',
      key: 'type',
      width: '55%',
      ...getColumnSearchProps('type'),
      sorter: true,
      sortDirections: ['descend', 'ascend'],
    },
    // {
    //   title: 'Qtd Inserção',
    //   dataIndex: 'qtdInsert',
    //   width: '13%',
    //   key: 'qtdInsert',
    //   // ...getColumnSearchProps('idcustomer'),
    //   sorter: true,
    //   sortDirections: ['descend', 'ascend'],
    // },
    {
      title: 'Valor',
      dataIndex: 'vlSale',
      key: 'vlSale',
      // ...getColumnSearchProps('vlAFaturar'),
      sorter: true,
      sortDirections: ['descend', 'ascend'],
      render: (valor) => (
        <span>
            {
              <Tag>
                  {new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(valor)}
              </Tag>
            }
        </span>
        ),
  },
    {
        title: 'Ações',
        // dataIndex: 'data',
        key: 'action',
            render: (_, record) => (

              
                <Space size="middle">
               
                  <Link to={'/service/' + record.idservice}>
                      { permission?.isinsert ? <EditOutlined style={{
                                    fontSize: '20px',
                                    color: '#4169E1'
                                  }} />
                                   :
                                   <EyeOutlined style={{
                                    fontSize: '20px',
                                    color: '#4169E1'
                                  }}  />}
                  </Link>
                  {
                      permission?.isremove ?
                          <Link to={'#'}>
                               <DeleteTwoTone 
                                  twoToneColor="#DC143C"
                                  style={{
                                    fontSize: '20px',
                                  }}  
                                  onClick={(e) => deleteService(record.idservice)} 
                                  />
                          </Link>
                      : 
                      ""
                  }
                </Space>
            ),
    },
  ];

  const handleDialogClose = () => {
    setOpenDialog(false);
    navigate("/listService");
    refreshPage();
  }

  return (

    <>

      <ResponsiveDialog 
            open={openDialog} 
            handleClose={handleDialogClose}
            title={titleDialog}
            message={messageDialog} 
            status={statusDialog}
      />

      <Table
        columns={columns} 
        dataSource={Array.isArray(data?.data) ? data.data : []}
        rowKey="idservice"
        onChange={handleTableChange}
        pagination={{
          current: data?.pagination?.currentPage || 1,
          pageSize: data?.pagination?.itemsPerPage || 10,
          total: data?.pagination?.totalItems || 0,
          showSizeChanger: true,
          showQuickJumper: true,
          showTotal: (total, range) => `${range[0]}-${range[1]} de ${total} itens`,
          pageSizeOptions: ['10', '20', '50', '100'],
          onChange: (page, pageSize) => {
            console.log("🔄 [TableService] Mudando para página:", page, "Tamanho:", pageSize);
            if (onPageChange) {
              onPageChange(page, pageSize);
            }
          },
          onShowSizeChange: (current, size) => {
            console.log("🔄 [TableService] Mudando tamanho da página:", size);
            if (onPageChange) {
              onPageChange(1, size);
            }
          }
        }}
      />
    </>
     
  )
  

};

export default TableService;
